import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchMiniTitle = createAsyncThunk(
  "fetchMiniTitle",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/mini_title/list.php";
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.mini_title;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchMiniTitleSearch = createAsyncThunk(
  "fetchMiniTitleSearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/mini_title/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.mini_title;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchMiniTitleEdit = createAsyncThunk(
  "fetchMiniTitleEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/mini_title/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.mini_title[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveMiniTitle = createAsyncThunk(
  "saveMiniTitle",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/mini_title/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.mini_title) return result.data.mini_title;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editMiniTitle = createAsyncThunk(
  "editMiniTitle",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/mini_title/update.php";
    const authorization = getToken();
    const options = {
      method: "put",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.mini_title) return result.data.mini_title;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteMiniTitle = createAsyncThunk(
  "deleteMiniTitle",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/mini_title/delete.php?id=" +
      id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
